function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME UI

 There are three general UI instructions that are tracked by games universally
 so that on re-load the UI can be appropriately updated. These are the Game Log, 
 Game Status and Game Controls.

 - log - an array of game updates
 - status - a single sentence describing state of processing
 - controls - a flexible HTML box for making game choices

 All of these functions should be passed raw-text with whatever minimal-markup
 is needed for internal functionality. You can write something to the log that
 contains the HTML needed for cards to track mouseover, for instance, but should
 not provide WRAPPING HTML around the log entry or status market.

 This class also provides GameHud integration, as the GameHud is a standard 
 component that has both a STATUS and CONTROL space. If your game has the GameHud
 activated and you run updateStatus() or updateControls() you will see the 
 gamehud UI components updated and formatted properly. In the event tha the 
 GameHud is in use, this component will work with the GameHud to properly wrap
 the updates so that they are formatted properly.

 For any more complicated UI requirements, please have the games override these
 functions and merge / combine input streams to update whatever custom UI components
 they have created and/or are using.

**********************************************************************************/
var SaitoOverlay = require('./../../saito/ui/saito-overlay/saito-overlay');
var GameUI = /*#__PURE__*/function () {
  function GameUI() {
    _classCallCheck(this, GameUI);
  }
  return _createClass(GameUI, [{
    key: "updateControls",
    value: function updateControls(str) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!force && this.lock_interface) {
        console.warn('GT [updateControls] Attempting to change locked controls interface with ', str);
        return;
      }
      this.game.controls = str;
      if (!this.gameBrowserActive()) {
        return 0;
      }
      try {
        document.querySelectorAll('.controls').forEach(function (el) {
          el.innerHTML = str;
        });
        if (document.getElementById('controls')) {
          document.getElementById('controls').innerHTML = str;
        }
        if (this.useHUD) {
          this.hud.updateControls(str);
        }
      } catch (err) {
        console.error('GT [updateControls] Error: ', err);
      }
    }
  }, {
    key: "updateLog",
    value: function updateLog(str) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      try {
        this.game.log.unshift(str);
        if (this.game.log.length > this.log_length) {
          this.game.log.splice(length);
        }
        if (this.gameBrowserActive() && this.log.rendered) {
          this.log.updateLog(str, force);
          //
          // adds mouseover to cards in log
          //
          if (this.useCardbox) {
            this.cardbox.attachCardEvents();
          }
        }
      } catch (err) {}
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(str) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      //
      // no-op if this status is already on screen -- queue commands re-fire on
      // every pass, and repainting the same status flickers the UI (and would
      // needlessly clear the controls). the DOM check keeps this safe across
      // body re-renders that empty the status container.
      //
      if (!force && str === this.game.status) {
        var el = document.getElementById('status');
        if (el && el.innerHTML === str) {
          return;
        }
      }
      this.updateControls('', force);
      try {
        this.game.status = str;
        if (!this.gameBrowserActive()) {
          return;
        }
        document.querySelectorAll('.status').forEach(function (el) {
          el.innerHTML = str;
        });
        if (document.getElementById('status')) {
          document.getElementById('status').innerHTML = str;
        }

        // back button inserted here
        if (this.useHUD) {
          this.hud.updateStatus(str);
        }
        if (this.useCardbox) {
          this.cardbox.attachCardEvents();
        }
      } catch (err) {
        console.error('GT [updateStatis] Error: ', err);
      }
    }

    /**
     *  Update Status (in HUD) and include a graphical display/textual description of cards (either provided or in one's hand)
     *  @param message - text (non-HTML formatted message) to insert in the (HUD) status
     *  @param cards - an array of cards (indices to this.game.deck[].cards)
     *
     */
  }, {
    key: "updateStatusAndListCards",
    value: function updateStatusAndListCards() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cards = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var mycallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      //
      // update the status
      //
      if (message !== null) {
        this.updateStatus("".concat(message));
      }

      //
      // observers do not get controls
      //
      if (this.game.player == 0) {
        return 0;
      }

      //
      // update the controls
      //
      if (this["interface"] === 1) {
        this.updateControls("<div class=\"game-cardgrid hide-scrollbar\">".concat(this.returnCardList(cards), "</div>"));
      } else if (this["interface"] === 2) {
        this.updateControls("".concat(this.returnCardList(cards)));
      }

      //
      // allow cardbox to attach popups to message
      //
      if (this.useCardbox) {
        this.cardbox.attachCardEvents();
      }
      if (mycallback != null) {
        this.attachCardboxEvents(mycallback);
      }
    }

    /**
     *  Update Status (in HUD) and include a graphical display/textual description of cards (either provided or in one's hand)
     *  @param message - text (non-HTML formatted message) to insert in the (HUD) status
     *  @param optionHTML - an html list of actions a user can take
     *
     */
  }, {
    key: "updateStatusWithOptions",
    value: function updateStatusWithOptions() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var mycallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      //
      // update the status
      //
      this.updateStatus(message);

      //In case the controls are inside the status (and thus got wiped out), rerender with a hook for controls
      if (!document.getElementById('controls') && !document.querySelector('.controls')) {
        this.updateStatus(message + "<div id=\"controls\"></div>");
      }

      //
      // observers do not get controls
      // except we might want for meta-game functions...
      /*if (this.game.player == 0) {
        return;
      }*/

      //
      // update the controls
      //
      this.updateControls(options);

      //
      // allow cardbox to attach popups to message
      //
      if (this.useCardbox) {
        this.cardbox.attachCardEvents();
      }
      if (mycallback != null) {
        this.attachCardboxEvents(mycallback);
      }
    }

    //
    // deprecated but included for convenience
    //
  }, {
    key: "attachCardboxEvents",
    value: function attachCardboxEvents() {
      var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (fn != null) {
        this.hud.attachControlCallback(fn);
      }
    }
  }, {
    key: "unbindBackButtonFunction",
    value: function unbindBackButtonFunction() {
      this.hud.back_button = false;
      this.hud.back_button_callback = null;
    }
  }, {
    key: "bindBackButtonFunction",
    value: function bindBackButtonFunction(mycallback) {
      // for HUD
      this.hud.back_button = true;
      this.hud.back_button_callback = mycallback;
      // for independent button
      try {
        var back_button = document.getElementById('back_button');
        // Make it dyanmically visible
        back_button.style.display = 'block';
        back_button.onclick = function (e) {
          mycallback();
        };
      } catch (err) {}
    }

    ///
    // These three functions are used by Blackjack and Imperium ...
    // but were delete in refactor / readded by WASM
    // TODO: fix this
    ///
  }, {
    key: "lockInterface",
    value: function lockInterface() {
      this.lock_interface = 1;
      this.lock_interface_step = this.game.queue[this.game.queue.length - 1];
    }
  }, {
    key: "unlockInterface",
    value: function unlockInterface() {
      this.lock_interface = 0;
    }
  }, {
    key: "mayUnlockInterface",
    value: function mayUnlockInterface() {
      if (this.lock_interface_step === this.game.queue[this.game.queue.length - 1]) {
        return 1;
      }
      return 0;
    }

    ///////////////////////////////////////////////////////////////////////////////////////
    ///////////// META USER INTERFACE /////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "setPlayReminder",
    value: function setPlayReminder() {
      var _this = this;
      //We can assume anyone holding their phone is going to be paying attention!
      if (this.app.browser.isMobileBrowser(navigator.userAgent) || this.play_reminder) {
        return;
      }
      this.play_reminder = setTimeout(function () {
        var newOverlay = new SaitoOverlay(_this.app, _this, false, true, true);
        newOverlay.show("<div class=\"message_box\">the move is yours</div>");
        window.removeEventListener('mousemove', clearTimer);
      }, 15000);
      var clearTimer = function clearTimer() {
        clearTimeout(_this.play_reminder);
        _this.play_reminder = null;
      };
      window.addEventListener('mousemove', clearTimer, {
        once: true
      });
    }
  }, {
    key: "notifyMove",
    value: function notifyMove() {
      if (!this.gameBrowserActive() || this.ignore_notifications) {
        return;
      }

      //Flash tab
      this.app.browser.createTabNotification('New Move', this.returnName());
      //Play a sound
      this.playChime();
    }
  }, {
    key: "playChime",
    value: function playChime() {
      var _this2 = this;
      if (this.app.browser.active_tab || !this.game_move_notification) {
        return;
      }
      if (this.beeping) {
        return;
      }
      this.beeping = setTimeout(function () {
        _this2.beeping = null;
      }, 1000);
      try {
        this.game_move_notification.play();
      } catch (err) {
        console.error('ERROR: user not engaging with application', err);
      }
    }
  }, {
    key: "setShotClock",
    value: function setShotClock() {
      var _this3 = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
      var pause_on_activity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      this.clearShotClock();
      if (!target) {
        console.warn('GT [setShotClock] empty target!');
        return;
      }
      var elem = document.querySelector(target);
      if (elem) {
        this.app.browser.addElementToSelector("<div class=\"animated-mask\"></div>", target);
        this.shot_clock = setTimeout(function () {
          _this3.clearShotClock();

          //
          // the UI may have been re-rendered (or repurposed entirely, e.g. by a
          // game-over) since the clock was armed -- only auto-click a control
          // that still matches the selector we were armed for
          //
          var clickable = elem.isConnected ? elem : document.querySelector(target);
          if (!clickable) {
            console.warn("GT [setShotClock] not auto-clicking '".concat(target, "' -- control was replaced or removed"));
            return;
          }
          if (callback) {
            callback();
          }
          clickable.click();
        }, timer);
        $('.animated-mask').animate({
          width: '0px'
        }, timer);
        if (pause_on_activity) {
          document.body.addEventListener('click', function () {
            _this3.clearShotClock(false);
          }, {
            once: true
          });
        }
      } else {
        console.warn('GT [setShotClock] target not found!');
      }
    }
  }, {
    key: "clearShotClock",
    value: function clearShotClock() {
      var remove_mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.shot_clock) {
        clearTimeout(this.shot_clock);
        this.shot_clock = null;
        $('.animated-mask').stop();
      }
      if (remove_mask) {
        $('.animated-mask').remove();
      } else {
        $('.animated-mask').addClass('flash3');
      }
    }
  }, {
    key: "promptMove",
    value: function promptMove() {
      var _this4 = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      this.clearShotClock();
      if (!target) {
        console.warn('GT [promptMove] empty target!');
        return;
      }
      var elem = document.querySelector(target);
      if (elem) {
        this.app.browser.addElementToSelector("<div class=\"animated-mask flash2\"></div>", target);
        this.shot_clock = setTimeout(function () {
          if (timer > 1000) {
            timer -= 1000;
          }
          _this4.promptMove(target, timer);
        }, timer);
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////   END GAME USER INTERFACE   ////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "gameOverUserInterface",
    value: function gameOverUserInterface() {
      var winner = this.game.winner;
      var reason = this.game.reason;

      //Stop players from clicking more
      this.removeEvents();

      // Game is over, we don't care if people navigate away
      this.app.browser.unlockNavigation();

      /////////////////////////////////////////////////////
      // Update the Game UI to reflect the end of the game
      /////////////////////////////////////////////////////
      var readable = '';
      //Check if multiple winners, or none
      if (winner.includes(this.publicKey)) {
        readable = 'You win';
      } else {
        if (Array.isArray(winner)) {
          var _iterator = _createForOfIteratorHelper(winner),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var w = _step.value;
              readable += this.app.keychain.returnUsername(w) + ', ';
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          readable = readable.substring(0, readable.length - 2) + ' win';
          if (winner.length == 1) {
            readable += 's';
          }
        } else {
          readable = this.app.keychain.returnUsername(winner) + ' wins';
        }
      }

      //Include reason if given
      if (reason != '') {
        readable += ' by ' + reason;
      } else {
        readable += '!';
      }

      //Just state reason if no winners
      if (winner.length == 0 || reason == 'cancellation') {
        readable = reason;
      }
      readable = 'Game Over: ' + readable;
      try {
        this.hud.back_button = false;
        this.updateLog(readable);
        this.updateStatusForGameOver(readable, reason !== 'cancellation' && !this.opengame);
      } catch (err) {
        console.error('GT [gameoverUserInterface] Error: ', err);
      }
    }
  }, {
    key: "updateStatusForGameOver",
    value: function updateStatusForGameOver(status, allowRematch) {
      var _this5 = this;
      var target = this.app.options.homeModule || 'Arcade';
      allowRematch = allowRematch && this.game.player !== 0 && this.game.players.length == 2;
      var options = "<ul>\n                      <li class=\"textchoice\" id=\"confirmit\">Return to ".concat(target, "</li>\n                      ").concat(allowRematch ? '<li class="textchoice" id="rematch">Rematch</li>' : '', "\n                   </ul>");
      this.hud.back_button = false;
      this.updateStatusWithOptions(status, options);
      if (document.getElementById('rematch')) {
        document.getElementById('rematch').onclick = function (e) {
          _this5.initialize_game_run = 0;
          e.currentTarget.onclick = null;
          _this5.app.connection.emit('arcade-issue-challenge', {
            game: _this5.name,
            players: _this5.game.players,
            options: _this5.game.options
          });
        };
      }
      if (document.getElementById('confirmit')) {
        document.getElementById('confirmit').onclick = function (e) {
          document.getElementById('confirmit').onclick = null; //If player clicks multiple times, don't want callback executed multiple times
          _this5.exitGame();
        };
      }

      ////////////////////////////////////////
      // Attach Listeners for rematch actions
      ////////////////////////////////////////
      this.app.connection.on('arcade-challenge-issued', function (tx) {
        var btn = document.getElementById('rematch');
        if (btn) {
          if (tx.isFrom(_this5.publicKey)) {
            btn.innerHTML = 'Rematch requested';
          } else {
            btn.innerHTML = 'Accept Rematch';
            // We could change the functionality here... but... should work
          }
        }
      });
      this.app.connection.on('arcade-game-initialize-render-request', function (game_id) {
        _this5.updateStatus('Preparing rematch...');
        _this5.updateControls();
        _this5.browser_active = 0; //Hack to simulate not being in the game mod
      });
      this.app.connection.on('arcade-game-ready-render-request', function (game_details) {
        var status = document.getElementById('status') || document.querySelector('.status');
        var controls = document.getElementById('controls') || document.querySelector('.controls');
        if (controls) {
          controls.innerHTML = "<ul><li class=\"textchoice\" id=\"go\">start game</li></ul>";
          status.innerHTML = 'game ready';
        } else {
          status.innerHTML = "game ready<ul><li class=\"textchoice\" id=\"go\">start game</li></ul>";
        }
        if (document.getElementById('go')) {
          document.getElementById('go').onclick = function (e) {
            _this5.app.browser.unlockNavigation();
            e.currentTarget.onclick = null;
            navigateWindow("/".concat(game_details.slug), 100);
          };
        }
      });
    }
  }, {
    key: "updateStatusForPlayerOut",
    value: function updateStatusForPlayerOut(status) {
      var _this6 = this;
      var allowObserver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target = this.app.options.homeModule || 'Arcade';
      var options = "<ul><li class=\"textchoice\" id=\"confirmit\">Return to ".concat(target, "</li>");

      //if (allowObserver) {
      //  options += '<li class="textchoice" id="observer">Stay and Watch</li>';
      //}

      options += "</ul>";
      this.hud.back_button = false;
      this.halted = 1;
      this.updateStatusWithOptions(status, options);
      if (document.getElementById('observer')) {
        document.getElementById('observer').onclick = function (e) {
          _this6.resetGameWithFewerPlayers();
          _this6.unlockInterface();
          _this6.halted = 0;
        };
      }
      document.getElementById('confirmit').onclick = function (e) {
        document.getElementById('confirmit').onclick = null;
        _this6.exitGame();
      };
      this.lockInterface();
    }
  }]);
}();
module.exports = GameUI;